import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-4xl" }
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = { class: "flex flex-col gap-1 md:flex-row md:justify-between" }
const _hoisted_4 = { class: "flex w-full justify-between" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = {
  key: 1,
  class: "bg-green-500 text-white rounded-xl p-1 text-xs"
}
const _hoisted_7 = { class: "flex gap-2" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "italic"
}
const _hoisted_11 = { class: "flex flex-col md:flex-row gap-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-phone" }, null, -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "text-gray-500 italic"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope" }, null, -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "text-gray-500 italic"
}

import PConfirmDialog from "primevue/confirmdialog";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import PInput from "primevue/inputtext";
import PPaginator from "primevue/paginator";
import { useToast } from "primevue/usetoast";
import { computed, onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import PButton from "primevue/button";
import { useConfirm } from "primevue/useconfirm";
import ClientForm from "@/components/shared/ClientForm.vue";
import { useNotify } from "@/composables/useNotify";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const confirm = useConfirm();
const { t } = useI18n();
const { successToast, errorToast } = useNotify({ t });
const toast = useToast();
const store = useStore();
const word = ref();
const result = ref();
const isLoading = ref(false);
const activeClient = ref<number>(-1);
const selectClient = (index: number) => {
  activeClient.value = index;
};
const closeAll = () => {
  activeClient.value = -1;
};
const canShowEditButtonsOnClient = computed(() => {
  return activeClient.value < 0;
});
const updateAClient = async (client: any) => {
  try {
    await store.dispatch("client/CHANGE_DETAILS", client);
    closeAll();
    retrieveClients({ page: result.value.currentPage, word: word.value });
    successToast({ title: t("client"), detail: t("updatedSuccessfully") });
  } catch (e: any) {
    errorToast({ title: t("client"), error: e.message });
  }
};

const deleteClient = (client: any) => {
  confirm.require({
    message: `${t("deletingClient")} ${client.firstName ?? ""} ${
      client.lastName ?? ""
    }  `,
    header: t("confirmation"),
    icon: "pi pi-exclamation-triangle",
    accept: async () => {
      try {
        await store.dispatch("client/DELETE_CLIENT", client);
        closeAll();
        retrieveClients({ page: result.value.currentPage, word: word.value });
        successToast({ title: t("client"), detail: t("deletedSuccessfully") });
      } catch (e: any) {
        errorToast({ title: t("client"), error: e.message });
      }
    },
  });
};

const retrieveClients = async ({ page = 1, word = undefined }) => {
  toast.add({
    severity: "info",
    summary: t("loading"),
  });
  isLoading.value = true;
  const params: Record<string, unknown> = { page };
  if (word) {
    params.word = word;
  }
  result.value = await store.dispatch("client/LIST_CLIENTS", params);
  isLoading.value = false;
  toast.removeAllGroups();
};

onBeforeMount(async () => {
  await retrieveClients({});
});
const changePage = async (pageState) => {
  closeAll();
  await retrieveClients({ page: pageState.page + 1, word: word.value });
};
const search = async () => {
  closeAll();
  await retrieveClients({ page: 1, word: word.value });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", {
      class: _normalizeClass([{ 'disabled-content': isLoading.value }, "flex flex-col gap-4"])
    }, [
      _createVNode(_unref(PConfirmDialog)),
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("clients")), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(PInput), {
          modelValue: word.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((word).value = $event)),
          class: "w-full block",
          placeholder: _ctx.$t('client')
        }, null, 8, ["modelValue", "placeholder"]),
        _createVNode(_unref(PButton), {
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (search())),
          class: "p-button rounded-full self-end"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("search")), 1)
          ]),
          _: 1
        })
      ]),
      (result.value?.data)
        ? (_openBlock(), _createBlock(_unref(Accordion), {
            key: 0,
            activeIndex: activeClient.value,
            onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop","prevent"]))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.value?.data, (client, clientIndex) => {
                return (_openBlock(), _createBlock(_unref(AccordionTab), {
                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop","prevent"])),
                  key: clientIndex
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "p-2 flex flex-col gap-2 w-full",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("p", _hoisted_5, [
                            (client.gender)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t(client.gender === "MALE" ? "MALE" : "FEMALE")), 1)
                                ], 64))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(client.firstName) + " " + _toDisplayString(client.lastName) + " ", 1),
                            (client.isOnline)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("online")), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["pi pi-pencil", { invisible: !_unref(canShowEditButtonsOnClient) }]),
                              onClick: ($event: any) => (selectClient(clientIndex))
                            }, null, 10, _hoisted_8),
                            _createElementVNode("i", {
                              class: "pi pi-trash",
                              onClick: ($event: any) => (deleteClient(client))
                            }, null, 8, _hoisted_9)
                          ])
                        ]),
                        (client.createdAt)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$t("createdAt")) + " " + _toDisplayString(client.createdAt), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", null, [
                          _hoisted_12,
                          _createTextVNode("  "),
                          (client.phoneNumber)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(client.phoneNumber), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("unavailable")), 1))
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_15,
                          _createTextVNode("  "),
                          (client.email)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(client.email), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t("unavailable")), 1))
                        ])
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    (clientIndex === activeClient.value)
                      ? (_openBlock(), _createBlock(ClientForm, {
                          key: 0,
                          "is-update": "",
                          client: client,
                          onCancel: _cache[3] || (_cache[3] = ($event: any) => (closeAll())),
                          onSave: updateAClient
                        }, null, 8, ["client"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["activeIndex"]))
        : _createCommentVNode("", true)
    ], 2),
    (result.value)
      ? (_openBlock(), _createBlock(_unref(PPaginator), {
          key: 0,
          class: _normalizeClass({ 'disabled-content': isLoading.value }),
          template: "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink",
          currentPageReportTemplate: "{currentPage} / {totalPages}",
          "total-records": result.value?.totalCount,
          rows: result.value?.pageSize,
          modelValue: result.value.currentPage,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((result.value.currentPage) = $event)),
          "page-link-size": 10,
          onPage: changePage
        }, null, 8, ["class", "total-records", "rows", "modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})